import { useEffect, useState, useRef } from "react";
import tw from "tailwind-styled-components";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import Config from "../../Config";
import { useSelector, useDispatch } from "react-redux";
import { useMutation } from "react-query";
import {
    DashboardSkeletonForSalesHead,
} from "../../Components/SkeletonLoading";
import QuickAction from "../../Components/Dashboard/QuickAction";
import Tables from "../../Components/Dashboard/Tables";
import ExpenseIncomeChart from "../../Components/Dashboard/ExpenseIncomeChart";
import OccupancyChart from "../../Components/Dashboard/OccupancyChart";
import { Save_VendorTypes, Save_Partners, Save_PendingTasks, Save_Locations, Select_Property, Select_Location, Save_Staff_Clients, Save_BankAccounts, Save_isStampRequired, Save_isPayoutEnabled, Save_User, Save_StaffList, Save_Vendors } from "../../Redux/actions";
import CollectionSummaryCard from "../../Components/Dashboard/CollectionSummaryCard";
import moment from "moment";
import OperationalInsightsRow from "../../Components/Dashboard/OperationalInsightsRow";
import PropertiesFilterDropdown from "../../Components/PropertiesFilterDropdown";
import DateRange from "../../Components/DateRange";
import LocationsFilterDropdown from "../../Components/LocationsFilterDropdown";
import { BoxTitle } from "../../Components/Styles/PageStyles";
import SideModal from "../../Components/SideModal";
import AnalyticsSideModal from "../../Components/Dashboard/AnalyticsSideModal";
import ComplaintAnalyticsSideModal from "../../Components/Dashboard/ComplaintAnalyticsSideModal";
import { hasPermission } from "../../helpers";
import KPIs from "../../Components/Inventory/Dashboard/KPIs";
import PerformanceTable from "../../Components/Sales/Dashboard/PerformanceTable";
import PieChart from "../../Components/Sales/Dashboard/PieChart";
import LeadSourceTable from "../../Components/Sales/Dashboard/LeadSourceTable";
import MealResponseChart from "../../Components/Inventory/Dashboard/MealResponseChart";
import { MdKeyboardArrowDown, MdOutlineChevronRight, MdOutlineFastfood } from "react-icons/md";
import { FaAppleAlt, FaArrowLeft, FaArrowRight, FaCoffee, FaConciergeBell, FaDrumstickBite, FaCookieBite, FaRegCalendarAlt, FaUtensils } from "react-icons/fa";
import CustomCalendar from "../../Components/Common/CustomCalendar";
import { format } from "date-fns";
import PurchaseTransferChart from "../../Components/Inventory/Dashboard/PurchaseTransferChart";
import StockPieChart from "../../Components/Inventory/Dashboard/StockPieChart";
import StockTable from "../../Components/Inventory/Dashboard/StockTable";
//import Calendar from "react-calendar";


const Dashboard = () => {
    const dispatch = useDispatch();
    const [propertyType, setPropertyType] = useState("Current Property");
    const user = useSelector((state) => state.UserReducer.user);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    const [purchaseTransferGraph, setPurchaseTransferGraph] = useState();
    const [stockTableData, setStockTableData] = useState();
    const [stockPieChart, setStockPieChart] = useState();
    const calendarRef = useRef(null);

    const property = useSelector(
        (state) => state.SelectPropertyReducer.selectProperty
    );
    const selectedPartner = useSelector(
        (state) => state.SelectedPartnerReducer.selectPartner
    );

    const canViewFinance = hasPermission("VIEW_FINANCIAL_SUMMARY", user);

    const defaultLocations = {
        id: 0,
        name: "All Locations",
        clientId: 0,
    };
    const [apiData, setApiData] = useState();
    //const [clientSummary, setClientSummary] = useState();
    const [foodSummary, setFoodSummary] = useState();
    //const [allPropertySummary, setAllPropertySummary] = useState();
    const [currentPropertySummary, setCurrentPropertySummary] = useState();
    const [staffSummary, setStaffSummary] = useState();
    const [expenseStats, setExpenseStats] = useState();
    const [expanseAllMonthlyGraph, setExpanseAllMonthlyGraph] = useState();
    const [expanseCurrMonthlyGraph, setExpanseCurrMonthlyGraph] = useState();
    const [expanseCurrYearlyGraph, setExpanseCurrYearlyGraph] = useState();
    const [expanseAllYearlyGraph, setExpanseAllYearlyGraph] = useState();
    const [allOccupancyGraph, setAllOccupancyGraph] = useState();
    const [currOccupancyGraph, setCurrOccupancyGraph] = useState();
    const [complaintSummary, setComplaintSummary] = useState();
    const [businessImpactSummary, setBusinessImpactSummary] = useState();
    const lastFetchRef = useRef(null);
    const [leadSourceSummary, setLeadSourceSummary] = useState();

    const [startDate, setStartDate] = useState(
        moment().format("YYYY-MM-DD")
    );
    const [endDate, setEndDate] = useState(
        moment().endOf("month").format("YYYY-MM-DD")
    );
    const [selectedProperty, setSelectedProperty] = useState(property);
    const [selectedLocation, setSelectedLocation] = useState(defaultLocations);
    const properties = useSelector((state) => state.PropertyReducer.property);
    const locations = useSelector((state) => state.LocationsReducer.locations);
    const [isShowAnalytics, setIsShowAnalytics] = useState(false);
    const [isShowComplaintAnalytics, setIsShowComplaintAnalytics] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(() => ({
        startDate: moment().startOf("month").format("YYYY-MM-DD"),
        endDate: moment().endOf("month").format("YYYY-MM-DD"),
        propertyId: property?.id ?? 0,
        locationId: defaultLocations.id,
    }));

    const filteredProperties =
        selectedLocation?.id === 0
            ? properties
            : [
                properties[0],
                ...properties.filter(
                    (p) =>
                        p.locationId === selectedLocation.id ||
                        p.location?.id === selectedLocation.id
                ),
            ];

    useEffect(() => {
        if (!selectedLocation || !properties?.length) return;

        // If All Locations selected → force All Properties
        if (selectedLocation?.id === 0) {
            setSelectedProperty(properties[0]);
            dispatch(Select_Property(properties[0]));

            if (locations && locations.length > 0) {
                setSelectedLocation(locations[0]);
                dispatch(Select_Location(locations[0]));
            }
            return;
        }

        const isPropertyValid = properties.some(
            (p) =>
                p.id === selectedProperty?.id &&
                (p.locationId === selectedLocation.id ||
                    p.location?.id === selectedLocation.id)
        );

        if (!isPropertyValid) {
            setSelectedProperty(properties[0]); // 👈 index 0
            dispatch(Select_Property(properties[0]));
        }
    }, [selectedLocation, properties]);

    const onApplyFilters = () => {
        const formattedDate = moment(selectedDate).format("YYYY-MM-DD");

        dispatch(Select_Property(selectedProperty));
        dispatch(Select_Location(selectedLocation));

        setStartDate(formattedDate);
        setEndDate(formattedDate);

        setAppliedFilters({
            startDate: formattedDate,
            endDate: formattedDate,
            propertyId: selectedProperty?.id ?? 0,
            locationId: selectedLocation?.id ?? 0,
        });
    };

    const selectedDateFormatted = moment(selectedDate).format("YYYY-MM-DD");

    const canApply =
        !appliedFilters ||
        appliedFilters.startDate !== selectedDateFormatted ||
        appliedFilters.endDate !== selectedDateFormatted ||
        appliedFilters.propertyId !== selectedProperty?.id ||
        appliedFilters.locationId !== selectedLocation?.id;

    const fetchFunction = async () => {
        const query = buildQuery();
        const response = await axios.get(
            `${Config.apiUrl}/property/web/dashboard/${property?.id}?${query}`,
            {
                headers: {
                    authorization: "Bearer" + " " + user.token,
                    "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
                },
            }
        );
        return response.data;
    };

    const getSuccess = (res) => {
        if (res.isSuccess === false) error = true;
        else {
            setApiData(res?.data);
            setFoodSummary(res?.summary);
            //setAllPropertySummary(res?.allPropCollectionSummary);
            setCurrentPropertySummary(res?.curPropCollectionSummary);
            setLeadSourceSummary(res?.leadSourceSummary)
            setStaffSummary(res?.staffSummary);
            setExpenseStats(res?.expenseStats);
            setExpanseAllMonthlyGraph(res?.expenseGraph?.allProps?.monthlyData);
            setExpanseAllYearlyGraph(res?.expenseGraph?.allProps?.yearlyData);
            setExpanseCurrYearlyGraph(res?.expenseGraph?.curProp?.yearlyData);
            setExpanseCurrMonthlyGraph(res?.expenseGraph?.curProp?.monthlyData);
            setAllOccupancyGraph(res?.occupancyGraph?.allProps);
            setCurrOccupancyGraph(res?.occupancyGraph?.curProps);
            setPurchaseTransferGraph(res?.purchaseTransferGraphData)
            setStockPieChart(res?.itemSummary)
            setStockTableData(res?.inventoryStocks);
            dispatch(Save_VendorTypes(res?.vendorTypes || []));
            dispatch(Save_StaffList(res?.staffList || []));
            dispatch(Save_Vendors(res?.vendors || []));
            const realData = {
                ...user,       // keep existing user data
                defaultTenantFilter: res?.defaultTenantFilter || '',
            };

            dispatch(Save_User(realData));

            if (user.userType === Config.USER_TYPE.CLIENT) {
                dispatch(Save_Partners(res?.personalAndPartnerProperties));
            }
            if (user.userType === Config.USER_TYPE.STAFF) {
                dispatch(Save_Staff_Clients(res?.staffAccounts));
            }
            if (res?.pendingTasks) {
                dispatch(Save_PendingTasks(res.pendingTasks));
            }
            if (res?.locations) {
                dispatch(Save_Locations([defaultLocations, ...res.locations]));
            }
            setBusinessImpactSummary(res?.businessImpact);
            setComplaintSummary(res?.complaintSummary);
            if (res?.bankAccounts) {
                dispatch(Save_BankAccounts(res.bankAccounts));
            }
            if (res?.isStampPaperRequired != null) {
                dispatch(Save_isStampRequired(res.isStampPaperRequired));
            }

            if (res?.isPayoutEnabled != null) {
                dispatch(Save_isPayoutEnabled(res.isPayoutEnabled));
            }
        }
    };

    const getError = (res) => { };

    const {
        isLoading,
        mutate: getListMutate,
        error,
        data,
        isRefetching,
    } = useMutation(fetchFunction, {
        onSuccess: getSuccess,
        onError: getError,
    });

    const buildQuery = () => {
        const params = new URLSearchParams();

        if (startDate) params.append("startDate", startDate);
        if (endDate) params.append("endDate", endDate);
        if (selectedLocation?.id) params.append("locationId", selectedLocation.id);
        if (selectedProperty?.id) params.append("propertyId", selectedProperty.id);
        return params.toString();
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setIsCalendarOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        setIsCalendarOpen(false);
        //getListMutate(date);
    };

    const toggleCalendar = () => {
        setIsCalendarOpen(!isCalendarOpen);
    };

    const submitHandler = (values) => {
        setStartDate(moment(values.startDate).format("YYYY-MM-DD"));
        setEndDate(moment(values.endDate).format("YYYY-MM-DD"));
    };

    //dispatch(Select_Property(property))

    const handlePropertySelect = (property) => {
        setSelectedProperty(property);
    };

    const handleLocationSelect = (location) => {
        setSelectedLocation(location);
    };

    // Partner change → reset filters ONCE
    useEffect(() => {
        if (!selectedPartner?.clientId) return;

        setAppliedFilters({
            startDate: moment().startOf("month").format("YYYY-MM-DD"),
            endDate: moment().endOf("month").format("YYYY-MM-DD"),
            propertyId: 0,
            locationId: 0,
        });
    }, [selectedPartner?.clientId]);

    // useEffect(() => {
    //   if (!appliedFilters) return;

    //   getListMutate();
    // }, [appliedFilters, getListMutate]);

    useEffect(() => {
        if (!appliedFilters || !user?.token) return;

        const signature = JSON.stringify({
            token: user.token,
            filters: appliedFilters,
        });

        if (lastFetchRef.current === signature) return;

        lastFetchRef.current = signature;
        getListMutate();
    }, [appliedFilters, user?.token]);

    return (
        <Container>
            <DashboardHeader title="Dashboard">
                {/* <DateRange
                    submitHandler={submitHandler}
                    defaultLabel={`${moment(startDate).format("DD MMM yyyy")} - ${moment(endDate).format("DD MMM yyyy")}`}
                /> */}
                <div className="relative" ref={calendarRef}>
                    <div
                        className="flex items-center gap-2 px-3 h-10 bg-white border rounded-md cursor-pointer hover:border-blue-500 transition-all duration-200 min-w-[200px] hover:shadow-md"
                        onClick={toggleCalendar}
                    >
                        <FaRegCalendarAlt className="w-4 h-4 text-gray-500" />
                        <span className="text-sm text-gray-800 flex-1">
                            {format(selectedDate, "MMM d, yyyy")}
                        </span>
                        <MdKeyboardArrowDown
                            className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${isCalendarOpen ? 'rotate-180' : ''
                                }`}
                        />
                    </div>

                    {/* Calendar Dropdown */}
                    {isCalendarOpen && (
                        <div className="absolute right-0 mt-2 z-50 bg-white rounded-lg shadow-xl border p-3 min-w-[340px]">
                            <CustomCalendar
                                selectedDate={selectedDate}
                                handleDateChange={handleDateChange}
                            />
                        </div>
                    )}
                </div>

                <PropertiesFilterDropdown
                    properties={filteredProperties}
                    selectedProperty={selectedProperty}
                    onPropertySelect={handlePropertySelect}
                    placeholder="All Properties"
                    className="w-full md:w-[200px]"
                />

                {/* <LocationsFilterDropdown
                    locations={locations}
                    selectedLocation={selectedLocation}
                    onSelect={handleLocationSelect}
                    placeholder="All Locations"
                    className="w-full md:w-[200px]"
                /> */}

                <ApplyButton
                    disabled={!canApply}
                    type="button"
                    onClick={onApplyFilters}
                    className="md:ml-2 self-center md:self-auto"
                >
                    Apply
                </ApplyButton>
            </DashboardHeader>
            {(isLoading || isRefetching) && <DashboardSkeletonForSalesHead />}
            {!error && !isLoading && apiData && (
                <>
                    <KPIs
                        data={foodSummary}
                        setIsShowAnalytics={setIsShowAnalytics}
                        canViewFinance={false}
                    />

                    {/* <div className="grid grid-cols-1 gap-6 mt-6 ">
                        <PerformanceTable
                            staffSummary={staffSummary}
                        />
                    </div> */}
                    <TwoColGrid >
                        <MealResponseChart
                            summary={foodSummary}
                        />
                        <StockPieChart
                            summary={stockPieChart}
                        />
                    </TwoColGrid>
                    <TwoColGrid className="pb-12">
                        <PurchaseTransferChart
                            purchaseTransferGraph={purchaseTransferGraph}
                        />

                        <StockTable
                            stockTableData={stockTableData}
                        />
                    </TwoColGrid>
                </>
            )}
        </Container >
    );
};


const DashboardHeader = ({
    title = "Dashboard",
    children,
}) => {
    return (
        <Card>
            <Wrapper>
                {/* Left: Title */}
                <TitleWrapper>
                    <BoxTitle className="!mb-0 whitespace-nowrap">
                        {title}
                    </BoxTitle>
                </TitleWrapper>

                {/* Right: Filters / Actions */}
                <ActionsWrapper>
                    {children}
                </ActionsWrapper>
            </Wrapper>
        </Card>
    );
};

// const CustomCalendar = ({ handleDateChange, selectedDate }) => (
//     <div className="overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
//         {/* Calendar */}
//         <div className="p-4">
//             <Calendar
//                 onChange={handleDateChange}
//                 value={selectedDate}
//                 className="premium-calendar"

//                 prevLabel={
//                     <button className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white transition-all duration-200 hover:border-primary-color hover:bg-blue-50 hover:text-primary-color">
//                         <FaArrowLeft size={14} />
//                     </button>
//                 }

//                 nextLabel={
//                     <button className="flex h-10 w-10 items-center justify-center rounded-xl border border-gray-200 bg-white transition-all duration-200 hover:border-primary-color hover:bg-blue-50 hover:text-primary-color">
//                         <FaArrowRight size={14} />
//                     </button>
//                 }

//                 prev2Label={null}
//                 next2Label={null}

//                 tileClassName={({ date }) => {

//                     const isToday =
//                         format(date, "yyyy-MM-dd") ===
//                         format(new Date(), "yyyy-MM-dd");

//                     const isSelected =
//                         format(date, "yyyy-MM-dd") ===
//                         format(selectedDate, "yyyy-MM-dd");

//                     if (isSelected) return "calendar-selected";
//                     if (isToday) return "calendar-today";

//                     return "calendar-day";
//                 }}
//             />

//         </div>

//     </div>
// );


const Container = tw.div`Container`;
const TwoColGrid = tw.div`
  grid grid-cols-1 md:grid-cols-2 gap-6 mt-6
`;
const ApplyButton = tw.button`
  px-5 py-2
  rounded-md
  text-sm font-medium
  transition
  shadow-sm

  ${({ disabled }) =>
        disabled
            ? `
        bg-gray-200
        text-gray-400
        cursor-not-allowed
      `
            : `
        bg-gradient-to-r from-primary-color to-[#00A0FF] hover:brightness-110
        text-white
      `}
`;

const Card = tw.div`mt-2 md:mt-7 bg-white rounded-lg shadow-sm`;

const Wrapper = tw.div`flex flex-col lg:flex-row lg:items-center gap-4 px-4 py-3 md:px-6`;

const TitleWrapper = tw.div`shrink-0`;

const ActionsWrapper = tw.div`flex flex-col md:flex-row md:items-center gap-3 flex-1 justify-end p-2`;


export default Dashboard;